var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('StudentTestLoadWidget',{attrs:{"studentid":_vm.studentId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }